import { render, staticRenderFns } from "./WarehousingAdd.vue?vue&type=template&id=57bff644&scoped=true"
import script from "./WarehousingAdd.vue?vue&type=script&lang=js"
export * from "./WarehousingAdd.vue?vue&type=script&lang=js"
import style0 from "./WarehousingAdd.vue?vue&type=style&index=0&id=57bff644&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bff644",
  null
  
)

export default component.exports